import { gql } from '@apollo/client'

export const GET_LOGGED_IN_USER = gql`
  query loggedInUser_UI {
    user {
      id
      createdAt
      userIdentity
      firstName
      lastName
      email

      profilePicture {
        url
      }

      adminUser {
        id
        modules
        limitedPermissions
        dashboards {
          id
          title
          favourited
          projects {
            id
            name
          }
        }
        mobile
        builders {
          builder {
            id
            company {
              name
            }
            clerkOrganizationId
          }
        }
        roles {
          name
          permissions {
            resource
            action
          }
        }
        builder {
          builderSubcontractor {
            id
            company {
              name
              abn
            }
          }
          id
          logoUrl
          hideBuildPassLogos
          subscription
          builderMetadata
          isTrial
          trialExpiresAt
          clerkOrganizationId
          integrations {
            id
            integrationType
          }
          company {
            name
          }
          subscriptId
          defaultTimezone
          defaultLocale
          defaultLanguage
        }
      }
    }
  }
`

export const GET_LOGGED_IN_USER_PROJECTS = gql`
  query loggedInUserProjects_UI(
    $projectFilter: ProjectsForBuilderFilterInput
    $projectPaginationFilter: PaginationInput
  ) {
    projectsForBuilder(
      filter: $projectFilter
      pagination: $projectPaginationFilter
    ) {
      id
      name
      status
      address
      country
      latitude
      longitude
      procoreId
      startDate
      endDate
      timezone
      language
      locale
      builder {
        defaultTimezone
        defaultLocale
        defaultLanguage
      }
      siteTimings {
        dayOfWeek
        startTime
        endTime
      }
      projectSettings {
        hideDocumentsUntilInductionApproved
      }
      integrationConnections {
        id
        integrationIdentifier
        integration {
          integrationType
        }
      }
    }
    projectsForBuilderAggregation(
      filter: $projectFilter
      pagination: $projectPaginationFilter
    ) {
      totalCount
    }
  }
`

export const GET_LOGGED_IN_USER_SETTINGS = gql`
  query loggedInUserSettings_UI {
    checklistSettings {
      checklistCategories {
        id
        label
        icon
        colour
      }
      checklistCategoriesInNavigation
    }
    aiToolsSettings {
      aiToolsEnabled
      checklistAssistantEnabled
      imageTaggingEnabled
      siteDiarySummaryEnabled
      defectEnhancementEnabled
      toolboxSummaryEnabled
      documentSummaryEnabled
      contentTaggingEnabled
      locationImportEnabled
      contextualActionGeneratorEnabled
    }
    stylingSettings {
      primaryColour
      buttonTextColour
      primaryTextColour
    }
    userSettings {
      favourites
    }
    gallerySettings {
      defaultCompression
    }
  }
`

export const GET_LOGGED_IN_USER_REGISTERS = gql`
  query loggedInUserRegisters_UI($filter: RegisterFilterInput) {
    registers(filter: $filter) {
      id
      name
      identifierPrefix
      itemCount
    }
  }
`

export const UPDATE_USER = gql`
  mutation updateUserForSignup_UI($input: UpdateUserInput!) {
    updateUser(input: $input) {
      id
      firstName
      lastName
      email
    }
  }
`

export const UPDATE_WORKER_USER_ADMIN = gql`
  mutation updateWorkerUserAdmin_UI(
    $workerId: String!
    $input: UpdateUserInput!
  ) {
    updateWorkerUser_admin(workerId: $workerId, input: $input) {
      id
    }
  }
`

export const GET_USER_WITH_WORKER = gql`
  query userWithWorkerForPublicRoutes_UI {
    user {
      id
      createdAt
      email
      firstName
      lastName
      hasWorker
      worker {
        id
        subcontractors {
          id
          company {
            name
          }
        }
      }
    }
  }
`

export const GET_USER_WORKER_ID = gql`
  query userWorkerIdForPublicRoutes_UI {
    user {
      worker {
        id
      }
    }
  }
`
